import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  textTitle: {
    fontSize: '12px',
    fontFamily: 'Poppins',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#A2A5A8',
  },
  primary_text: {
    fontSize: 12,
  },
}));
